<template>
  <span v-if="bet">
    <div
      v-if="socketUpdate && anyOddChangedWithAgainConfirmation"
      class="odd-updated-area"
      :class="{
        socketUpdate: socketUpdate,
        anyOddChangedWithAgainConfirmation: anyOddChangedWithAgainConfirmation,
      }"
    ></div>
    <div
      class="odd-updated-area d-none"
      :class="{
        isAccepted: isAccepted,
      }"
    >
      <div class="left-text mr-2">
        {{ $t('BetSlip.OddsUpdated') }}
      </div>

      <a class="right-button" @click="acceptBet()">
        {{ $t('ACCEPT') }}
      </a>
    </div>
  </span>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  props: ['bet', 'socketUpdate'],
  computed: {
    ...mapState('betSlip', ['betConfirmationIds']),
    isAccepted() {
      return this.betConfirmationIds.indexOf(this.bet.OutcomeId) > -1;
    },
    anyOddChangedWithSocket() {
      return this.bet.wait_for_get_confirmation;
    },
    anyOddChangedWithAgainConfirmation() {
      return this.bet.wait_for_accept_get_confirmation;
    },
  },
  watch: {
    bet(newVal) {
      if (newVal && newVal.error && !this.socketUpdate) {
        this.removeBetConfirmationId(newVal);
      }
    },
    anyOddChangedWithSocket(newVal, oldVal) {
      //console.log({ newVal, oldVal });
      //if (newVal === true && oldVal === false) {
      this.$store.commit('betSlip/acceptAllOddsChange');
      this.$store.dispatch('betSlip/getBetConfirmations');
      //}
    },
  },
  methods: {
    ...mapMutations('betSlip', ['removeBetConfirmationId']),
    acceptBet() {
      this.$emit('accept');
    },
    acceptBetSelectionOddChange() {
      this.bet.bet.line_selections.forEach(l => {
        l.wait_for_accept_get_confirmation = false;
      });
    },
  },
  mounted() {
    if (this.bet && !this.socketUpdate) {
      this.removeBetConfirmationId(this.bet);
    }
  },
};
</script>
